import { INVOICE_ACTION } from '@/@core/data/enum/eInvoiceActionType';
import { getPaymentMethods } from '@/api/action-defines/e-invoice-management';
import { getListSerialsApi } from '@/api/action-defines/serial-management';
import dayjs from 'dayjs';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { required } from '@validations';
import flatPickr from 'vue-flatpickr-component';
import { PartnerCode } from '@/@core/data/enum/partnerCode';
import { getSitePartner } from '@/api/action-defines/site-management';
import { INVOICE_STATUS, TAX_AUTHORITY_STATUS } from "@/@core/data/enum/invoiceStatus.js";
import { viewPdfEInvoice} from "@/api/action-defines/e-invoice-management";
import { getDetailEInvoice ,getDetailEInvoiceReservationThirdApi} from "@/api/action-defines/e-invoice-management";
import Home from '@/views/pages/Home';

export default {
  components: {
    flatPickr,
    ValidationProvider,
    ValidationObserver,
  },

  props: {
    actionType: {
      type: String,
      required: false,
      default: INVOICE_ACTION.ADD_INVOICE,
    },
  },

  data() {
    return {
      isOpen: false,
      statusList: [...INVOICE_STATUS],
      taxAuthorityStatusList: [...TAX_AUTHORITY_STATUS],
      formData: {
        EinvoiceDate: '',
        InvoiceNo: '',
        Serial: null,
        FormInvoice: null,
        CustomerName: null,
        CustomerPhone: null,
        CustomerEmail: null,
        CompanyName: null,
        CustomerAddress: null,
        CustomerTax: null,
        BankName: null,
        BankAccount: null,
        PaymentMethodCode: '',
        Cccd: null,
        Passport: null,
        CompanyAddress: null,
      },
      EinvoiceDate: '',
      required,
      listSerial: [],
      listForm: [],
      paymentMethodList: [],
      flatPickrConfig: {
        dateFormat: 'd/m/Y',
      },
      partnerInfo: {},
      listReference: [],
      signStatus: null,
      invoiceStatuts: null,
      taxAuthorityStatus: null,
    }
  },

  async created() {
    console.log("actionType", this.actionType);
    await this.getPaymentMethods();
    await this.getListSerialAndForm();
    await this.getPartnerInfo();
    this.formData.EinvoiceDate = dayjs().toDate();
    const eInvoiceConfig = JSON.parse(localStorage.getItem('vuex') || '{}');
  
    this.formData.PaymentMethodCode = eInvoiceConfig.eInvoiceManagement.eInvoiceConfig.DefaultPayment || 'TM'
    let isRedirected = sessionStorage.getItem('isRedirected');
    if (isRedirected === "true"){
      const params = new URLSearchParams(window.location.search);
      let reservationIds = params.get('reservationIds');
      let hotelId = params.get('hotelId');
      let infoReservationId = params.get('infoReservationId');
      if (!reservationIds || !hotelId){
        return;
      }
      await this.getDetailEInvoiceReservation( infoReservationId ? infoReservationId : reservationIds, hotelId)
      .catch((err) => {
      });
    }
  },

  methods: {
    getSignStatusUI(status) {
      if(status) {
        return {
          text: this.$t('common_signed'),
          color: 'text-success'
        }
      } else {
        return {
          text: this.$t('common_not_signed'),
          color: 'text-warning'
        }
      }
    },
    
    getInvoiceStatusUI(statusId) {
      if(!this.statusList) return
     console.log(statusId);
     console.log(1);
      const status =  this.statusList.find(s => s.id === statusId)

      if(!status) return {
        text: '',
        styles: '',
      }
      
      return {
        ...status,
        text: this.$t(status.text)
      }
    },
    getTaxAuthorityStatusUI(statusId) {
      if(!this.taxAuthorityStatusList) return
     
      const status =  this.taxAuthorityStatusList.find(s => s.id === statusId)

      if(!status) return {
        text: '',
        styles: '',
      }
      
      return {
        ...status,
        text: this.$t(status.text)
      }
    },
    getDetailData() {
      return this.formData;
    },

    async getPartnerInfo() {
      const res = await getSitePartner();
      this.partnerInfo = res.Data;
    },

    setDefaultSerialAndForm() {
      this.formData.Serial = this.listSerial[0] && this.listSerial[0].value;
      this.formData.FormInvoice = this.listForm[0] && this.listForm[0].value;
    },

    
    async getListSerialAndForm() {
      const BodyData = {
        Status: {
          All: false,
          In: ['ACTIVE']
        }
      }
      getListSerialsApi({ BodyData }).then(res => {
        if(res.StatusCode === '200') {
          res.Data.map(item => {
            this.listForm.push({ value: item.Form, text: item.Form });
            this.listSerial.push({ value: item.Serial, text: item.Serial });
          })
          this.setDefaultSerialAndForm();
        }
      })
    },

    filterInput(value, field) {
      const regex = /^[a-zA-Z0-9]*$/;
      if(regex.test(value)) {
        this.formData[field] = value;
      }
    },

    formatter(value) {
      return value.replace(/[^a-zA-Z0-9]/g,'');
    },

    async getPaymentMethods() {
      const BodyData = {
        Partner: {
          All: false,
          In: [],
        }
      }
      getPaymentMethods({ BodyData })
        .then(res => {
          if (res.StatusCode === '200') {
            this.paymentMethodList = res.Data.map(method => {
              return {
                text: method.PaymentDescription,
                value: method.PaymentCode,
              }
            })
          }
        })
        .catch(err => {
          console.log(err)
        })
    },

    async saveCompany() {

    },

    async validateFormReturnInfor(){
      let res = [];
      if (this.formData.EinvoiceDate === null || this.formData.EinvoiceDate === ''){
        res.push('e_invoice_detail_invoice_date');
      }

      if (this.formData.Serial === null || this.formData.Serial === ''){
        res.push('e_invoice_detail_invoice_serial');
      }

      if (this.formData.FormInvoice === null || this.formData.FormInvoice === ''){
        res.push('e_invoice_detail_invoice_form');
      }

      if ((this.formData.CustomerName === null || this.formData.CustomerName === '') && (this.formData.CompanyName === null || this.formData.CompanyName === '')){
        res.push('common_buyer_or_common_company');
      }

      if (this.formData.PaymentMethodCode === null || this.formData.PaymentMethodCode === ''){
        res.push('common_payment_method');
      }
      await this.$refs.EInvoiceDetailForm.validate();
      return res;
    },
    async validateForm() {
      let res = false;
      await this.$refs.EInvoiceDetailForm.validate().then(success => {
        res = success;
      })
      return res;
    },
    async handleReferenceClick(id){
      const BodyDataGetDetail = {
        EInvoiceId: id,
      };
      this.einvoice = {};
      await getDetailEInvoice({ BodyData: BodyDataGetDetail })
        .then((res) => {
          if (res.StatusCode === "200") {
            this.einvoice = res.Data;
          } else {
            console.log(res.Messages);
          }
        })
        .catch((error) => {
          console.log(error);
      });

      if (this.einvoice){
        const BodyDataViewPdf = {
          InvoiceCreateStatus: this.einvoice.EInvoice.StatusEinvoice === 6 ? "Draft" : "Official",
          ezInvoiceId: this.einvoice.EInvoice.EzInvoiceId,
          ThirdPartyInvoiceNumber: this.einvoice.EInvoice.ThirdPartyInvoiceNumber,
          ThirdPartyInvoiceCode: "",
          TransactionId: this.einvoice.EInvoice.TransactionId,
          searchCode: this.einvoice.EInvoice.SearchCode,
          invtmp: 0,
          FormNo: this.einvoice.EInvoice.FormNo,
          Serial: this.einvoice.EInvoice.Serial ? this.einvoice.EInvoice.Serial : "",
          InvoiceType: 0,
          TypeEinvoice: 0
        };
        await viewPdfEInvoice({ BodyData: BodyDataViewPdf }).then(res => {
          if (res.StatusCode === '200') {
            this.$toast.success(this.$t('success'));
            if (res.Data.Type === 1){
              const base64PDF = res.Data.InvoicePDF;
              const byteCharacters = atob(base64PDF);
              const byteNumbers = Array.from(byteCharacters, c => c.charCodeAt(0));
              const byteArray = new Uint8Array(byteNumbers);

              const blob = new Blob([byteArray], { type: 'application/pdf' });
              const blobUrl = URL.createObjectURL(blob);
              window.open(blobUrl);
            }

            if (res.Data.Type === 2){
              const pdfUrl = res.Data.InvoicePDF; // link trả về từ API
              window.open(pdfUrl, '_blank');
            }
            this.$router.push({
              name: 'invoice-management',
              query: { reload: true }
            });
          }
        })

      }
    },
    async getDetailEInvoiceReservation(reservationId, hotelId) {
      const BodyData = {
        ModuleId: this.$store.state.eInvoiceManagement.moduleId,
        ReservationId: reservationId,
        HotelId: hotelId,
      };
      const res = await getDetailEInvoiceReservationThirdApi({ BodyData });

      if (res.StatusCode === '200' && res.Data) {

        let serialNo = this.listSerial.find(item => item.value === res.Data.InforEinvoice.SerialNo);
        if (serialNo !== undefined){
          this.formData.Serial = res.Data.InforEinvoice.SerialNo;
        }

        let formNo = this.listForm.find(item => item.value === res.Data.InforEinvoice.FormNo);
        if (formNo !== undefined){
          this.formData.FormInvoice = res.Data.InforEinvoice.FormNo;
        }

        this.formData.CustomerName = res.Data.InforEinvoice.Traveller.Fullname;
        this.formData.Cccd = res.Data.InforEinvoice.Traveller.IdentityNumber;
        this.formData.Passport = res.Data.InforEinvoice.Traveller.PassportNum;
        this.formData.BudgetCode = res.Data.InforEinvoice.Traveller.BudgetCode;
        this.formData.CustomerPhone = res.Data.InforEinvoice.Traveller.Mobile;
        this.formData.CustomerEmail = res.Data.InforEinvoice.Traveller.Email;

        this.formData.CustomerAddress = res.Data.InforEinvoice.Traveller.Address ?? "";

        this.formData.CompanyName = res.Data.InforEinvoice.Company ? res.Data.InforEinvoice.Company.CompanyName : "";
        this.formData.CompanyAddress = res.Data.InforEinvoice.Company ? res.Data.InforEinvoice.Company.ContactAddress : "";
        this.formData.CustomerTax = res.Data.InforEinvoice.Company ? res.Data.InforEinvoice.Company.CompanyVatCode: "";
      }
      else{
        this.$bvToast.toast('not_found_guest', {
          title: 'Lỗi',
          variant: 'danger',
          solid: true
        });
      }
    },
  },

  computed: {
    isShowStatusSign(){
      const { VIETTEL, SUN, MISA, VNPT, VNPT_V5, FAST, EASY} = PartnerCode;

      if (![VIETTEL, SUN, MISA, VNPT, VNPT_V5, FAST, EASY].includes(this.partnerInfo.PartnerCode) && this.actionType !== INVOICE_ACTION.ADD_INVOICE) {
        return true;
      }

      return false;

    },
    isDisable() {
      const {REPLACE_INVOICE, ADJUST_INVOICE, ADJUST_INVOICE_INFORMATION, ADD_INVOICE, CHANGE_INVOICE, ADJUST_INCREASE_INVOICE, ADJUST_DECREASE_INVOICE, ADJUST_INVOICE_VALUE} = INVOICE_ACTION;
      const allowEditList = [REPLACE_INVOICE, ADJUST_INVOICE, ADJUST_INVOICE_INFORMATION, ADD_INVOICE, CHANGE_INVOICE, ADJUST_INCREASE_INVOICE, ADJUST_DECREASE_INVOICE, ADJUST_INVOICE_VALUE];
      // Allow edit for any action type starting with "ADJUST_"
      if(allowEditList.includes(this.actionType) || this.actionType.startsWith('ADJUST_')) {
        return false;
      }
      return true;
    },
    getRequiredBuyer() {
      return 'required';
    },
  },
}